// components/SkeletonCircleText.jsx
import React from 'react';
import './Skeleton.css';


export default function SkeletonCircleText() {
    return (
        <div className="skeleton-circle-text">
            <div className="skeleton circle" />
            <div className="skeleton text-line short center" />
        </div>
    );
}
